import { _ } from "../../../polyglot/polyglot.js";
import { Widget } from "@foretagsplatsen/widgetjs";
import KeyFigureSelectionWidget from "../KeyFigureSelectionWidget/KeyFigureSelectionWidget.js";
import SwitchButton from "../../SwitchButton/SwitchButton.js";

/**
 * Give the user a choice between "Custom KPI" and "Known KPI". If the
 * later is chosen, the user has to select a known KPI from a list.
 *
 * @param {KeyFigure[]} allKeyFigures - List of all KPIs to choose from
 * if the user choses "Known KPI".
 */
export default class KeyFigureTypeChoiceWidget extends Widget {
	constructor({ allKeyFigures }) {
		super(...arguments);

		this._switchButton = new SwitchButton({
			state: false,
			dataTestName: "toggle-custom-known",
		});

		this._keyFigurePicker = new KeyFigureSelectionWidget({
			keyFigures: allKeyFigures,
		});

		if (allKeyFigures[0]) {
			this._keyFigurePicker.selectKeyFigure(allKeyFigures[0]);
		}

		this._switchButton.stateChanged.register(() => this.update());
	}

	hasSelectedNewCustomKeyFigure() {
		return !this._switchButton.getState();
	}

	selectedKeyFigure() {
		return this._keyFigurePicker.getSelection();
	}

	renderContentOn(html) {
		html.p(
			_(
				"Do you want your file to be saved as a new custom KPI or to replace the content of an existing KPI?",
			),
		);

		html.div(
			{ klass: "modal-options", "data-test": "replace-kpi-option" },
			html.div(
				{ klass: "modal-option" },
				html.h3(_("Replace existing KPI")),
				this._switchButton,
			),
		);

		if (!this.hasSelectedNewCustomKeyFigure()) {
			html.div(this._keyFigurePicker);
		}
	}
}
